import type { ComponentChildren } from 'preact';
import './ProposeCard.css';

export interface ProposeCardProps {
  /** The live SourceCitationChip for the capture this card proposes. */
  citation: ComponentChildren;
  /** Serif headline — the record this would create/update. */
  title: string;
  /** The interpretation-labelled summary line (composed of
   *  InterpretationLabel + verbatim text by the caller). */
  meta: ComponentChildren;
  /** "File to **Auditions** · attach the **sides PDF** from the email" —
   *  composed by the caller so the bold filing target/attachment stays
   *  semantic markup, not a string this component has to parse. */
  fileTarget: ComponentChildren;
  onApprove: () => void;
  /** Optional — the "Correct" door is shown only when the caller can open the
   *  proposed record to adjust it (Today's proposals do). A capture proposal
   *  whose only sensible resolutions are Approve / Not now omits it. */
  onCorrect?: () => void;
  onNotNow: () => void;
}

// Trust-posture primitive (3) — propose, don't just act. Composes the
// citation chip + interpretation labels + a filing target into one card
// whose only exit is a decision: Approve (the one gold CTA per screen),
// Correct, or Not now.
export function ProposeCard({ citation, title, meta, fileTarget, onApprove, onCorrect, onNotNow }: ProposeCardProps) {
  return (
    <div class="propose-card">
      {citation}
      <div class="propose-card__title">{title}</div>
      <div class="propose-card__meta">{meta}</div>
      <div class="propose-card__file">{fileTarget}</div>
      <div class="propose-card__btns">
        <button type="button" class="propose-card__btn propose-card__btn--approve" onClick={onApprove}>
          Approve
        </button>
        {onCorrect ? (
          <button type="button" class="propose-card__btn" onClick={onCorrect}>
            Correct
          </button>
        ) : null}
        <button type="button" class="propose-card__btn propose-card__btn--ghost" onClick={onNotNow}>
          Not now
        </button>
      </div>
    </div>
  );
}
